import { NonBFIExperienceActionType } from '../ExperienceConstants';
import { PermissionType } from '@apply/constants';
import { hasPermission } from '@apply/ui';

export const getNonBFIExperienceActions = (experience: { id: number; principalId: number }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actions: any[] = [];

    actions.push({
        id: NonBFIExperienceActionType.ModifyNonBfi,
        text: hasPermission(PermissionType.ExperienceEditor) ? 'Edit' : 'View',
        experienceId: experience.id,
        stylingMode: 'contained',
    });

    actions.push({
        id: NonBFIExperienceActionType.DeleteNonBfi,
        text: 'Delete',
        experienceId: experience.id,
        stylingMode: 'contained',
        disabled: !hasPermission(PermissionType.ExperienceEditor),
    });

    actions.push({
        id: NonBFIExperienceActionType.AuditHistory,
        text: 'Audit History',
        experienceId: experience.id,
        stylingMode: 'contained',
        disabled: false,
    });

    return actions;
};
